export default __webpack_public_path__ + "static/media/ic-whatsapp.c481737d.svg";